// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Експертні висновки» (Expert opinions, ключ `expert`, група `committees`). */
export const expertOpinionsManifest: IModuleManifest = {
  key: 'expert',
  group: 'committees',
  slug: 'expert-opinions',
  prefix: 'EXP',
  name: { en: 'Expert opinions', uk: 'Експертні висновки' },
  entities: [
    { key: 'expert', slug: 'expert', name: { en: 'Expert opinions', uk: 'Експертні висновки' }, main: true },
    { key: 'opinion_request', slug: 'opinion-request', name: { en: 'Opinion Requests', uk: 'Запити' }, main: false },
    { key: 'opinion_expert', slug: 'opinion-expert', name: { en: 'Opinion Experts', uk: 'Експерти' }, main: false },
    { key: 'opinion_document', slug: 'opinion-document', name: { en: 'Opinion Documents', uk: 'Документи' }, main: false },
    { key: 'opinion_status', slug: 'opinion-status', name: { en: 'Opinion Statuses', uk: 'Статуси' }, main: false },
  ],
  loadState: () => import('./state/expertOpinionsSlice').then((m) => m.expertOpinionsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
